import '../node_modules/phaser/dist/phaser.js';
import { sceneLoader } from './sceneLoader';
import './index.css';

sceneLoader();